import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, vModelRadio as _vModelRadio, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a12793c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-user-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Edit User Profile", -1))
const _hoisted_3 = { class: "toggle-switch" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "editToggle",
  class: "switch"
}, null, -1))
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "username" }, "Username", -1))
const _hoisted_7 = ["readonly"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "firstName" }, "First Name", -1))
const _hoisted_10 = ["readonly"]
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, "Last Name", -1))
const _hoisted_13 = ["readonly"]
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_16 = ["readonly"]
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"1.2em"} }, "Do you want to change your password?", -1))
const _hoisted_19 = { class: "password-change-options" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "yes" }, "Yes", -1))
const _hoisted_22 = ["disabled"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "no" }, "No", -1))
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "oldPassword" }, "Old Password", -1))
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "loader"
}
const _hoisted_29 = {
  key: 1,
  class: "verification-icon"
}
const _hoisted_30 = {
  key: 0,
  class: "success-message"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Password verified successfully!", -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 1,
  class: "failure-message"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Password does not match. Please try again.", -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 2,
  class: "form-group"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "forgotPassword" }, "I do not remember my old password", -1))
const _hoisted_38 = {
  key: 3,
  class: "form-group"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "newPassword" }, "New Password", -1))
const _hoisted_40 = {
  key: 1,
  class: "form-group"
}

import { ref, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useEmployeeStore } from '../stores/UserEmployee';
import { patchToUrl, postToUrl } from '../api/api';

interface PasswordVerificationRequest {
  password: string;
}

interface PasswordVerificationResponse {
  isPasswordCorrect: boolean;
}

interface UserData {
  id?: number;
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  password?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditUserProfile',
  setup(__props) {

const router = useRouter();
const employeeStore = useEmployeeStore();
const editableUser = computed(() => employeeStore.currentUser);
const isEditing = ref(false);
const passwordChange = ref('No');
const oldPassword = ref('');
const newPassword = ref('');
const forgotPassword = ref(false);
const verifying = ref(false);
const passwordVerified = ref(false);
const passwordVerificationFailed = ref(false);

onMounted(async () => {
  if (!employeeStore.currentUser) {
    await employeeStore.fetch();
  }
});

const handleForgotPassword = () => {
  if (forgotPassword.value) {
    const passwordResetUrl = '/custom-password-reset/';
    window.location.href = passwordResetUrl;
  }
};

const verifyOldPassword = async () => {
  verifying.value = true;
  passwordVerified.value = false;
  passwordVerificationFailed.value = false;

  const requestData: PasswordVerificationRequest = {
    password: oldPassword.value
  };

  try {
    const response = await postToUrl('/ops/api/verify-password/', requestData);

    if (typeof response === 'object' && 'isPasswordCorrect' in response) {
      const verificationResponse = response as PasswordVerificationResponse;
      passwordVerified.value = verificationResponse.isPasswordCorrect;
      passwordVerificationFailed.value = !verificationResponse.isPasswordCorrect;
    } else {
      console.error('Unexpected response format:', response);
      passwordVerificationFailed.value = true;
    }
  } catch (error) {
    console.error('Error during password verification:', error);
    passwordVerificationFailed.value = true;
  } finally {
    verifying.value = false;
  }
};


const saveUserProfile = async () => {
  const userData: UserData = {
    id: editableUser.value.user.id,
    username: editableUser.value.user.username,
    first_name: editableUser.value.user.first_name,
    last_name: editableUser.value.user.last_name,
    email: editableUser.value.user.email
  };

  if (passwordChange.value === 'Yes' && passwordVerified.value) {
    userData.password = newPassword.value;
  }

  try {
    const url = `/ops/api/Updateuser/${editableUser.value.user.id}/`;
    const response = await patchToUrl(url, userData);
    if (response && response.id) {
      alert('User profile updated successfully.');
      isEditing.value = false;
    } else {
      alert('Failed to update user profile. Please check the provided data.');
    }
  } catch (error) {
    alert('Failed to update user profile. Error: ' + error.message);
  }
};

const toggleEdit = () => {
  isEditing.value = !isEditing.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        id: "editToggle",
        type: "checkbox",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isEditing).value = $event))
      }, null, 512), [
        [_vModelCheckbox, isEditing.value]
      ]),
      _hoisted_4
    ]),
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          id: "username",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editableUser.value.user.username) = $event)),
          readonly: !isEditing.value,
          type: "text"
        }, null, 8, _hoisted_7), [
          [_vModelText, editableUser.value.user.username]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          id: "firstName",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editableUser.value.user.first_name) = $event)),
          readonly: !isEditing.value,
          type: "text"
        }, null, 8, _hoisted_10), [
          [_vModelText, editableUser.value.user.first_name]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _withDirectives(_createElementVNode("input", {
          id: "lastName",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editableUser.value.user.last_name) = $event)),
          readonly: !isEditing.value,
          type: "text"
        }, null, 8, _hoisted_13), [
          [_vModelText, editableUser.value.user.last_name]
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _withDirectives(_createElementVNode("input", {
          id: "email",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editableUser.value.user.email) = $event)),
          readonly: !isEditing.value,
          type: "email"
        }, null, 8, _hoisted_16), [
          [_vModelText, editableUser.value.user.email]
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            id: "yes",
            value: "Yes",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((passwordChange).value = $event)),
            disabled: !isEditing.value
          }, null, 8, _hoisted_20), [
            [_vModelRadio, passwordChange.value]
          ]),
          _hoisted_21,
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            id: "no",
            value: "No",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((passwordChange).value = $event)),
            disabled: !isEditing.value
          }, null, 8, _hoisted_22), [
            [_vModelRadio, passwordChange.value]
          ]),
          _hoisted_23
        ])
      ]),
      (passwordChange.value === 'Yes' && isEditing.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _withDirectives(_createElementVNode("input", {
                id: "oldPassword",
                type: "password",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((oldPassword).value = $event)),
                placeholder: "Enter your old password"
              }, null, 512), [
                [_vModelText, oldPassword.value]
              ]),
              _createElementVNode("button", {
                onClick: verifyOldPassword,
                disabled: verifying.value,
                class: "verify-button"
              }, "Verify", 8, _hoisted_27),
              (verifying.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                : _createCommentVNode("", true),
              (passwordVerified.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_29, "✔"))
                : _createCommentVNode("", true)
            ]),
            (passwordVerified.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
              : _createCommentVNode("", true),
            (passwordVerificationFailed.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
              : _createCommentVNode("", true),
            (!passwordVerified.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "forgotPassword",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((forgotPassword).value = $event)),
                    onChange: handleForgotPassword
                  }, null, 544), [
                    [_vModelCheckbox, forgotPassword.value]
                  ]),
                  _hoisted_37
                ]))
              : _createCommentVNode("", true),
            (passwordVerified.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _hoisted_39,
                  _withDirectives(_createElementVNode("input", {
                    id: "newPassword",
                    type: "password",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newPassword).value = $event)),
                    placeholder: "Create your new password"
                  }, null, 512), [
                    [_vModelText, newPassword.value]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (isEditing.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createElementVNode("button", {
              type: "button",
              class: "save-changes-btn",
              onClick: saveUserProfile
            }, "Save Changes")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})